module.exports = __webpack_public_path__ + "static/img/business10.78d166a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business10.jpg
// module id = vKxJ
// module chunks = 9